import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { useStripe } from '@stripe/react-stripe-js'
import { CardDetailFragment } from 'generated/resources/graphql'

import TextField from 'modules/core/components/TextField'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import useCardDetails, { isCardDetails } from 'modules/expenses/hooks/useCardDetails'

import { SidebarSection } from '../_SidebarSection'
import { interFont, pinStyle } from './styles'

const useViewPin = (card: CardDetailFragment) => {
  const pinRef = React.useRef(null)
  const [pinVisible, setPinVisible] = React.useState(false)
  const togglePinVisible = () => {
    setPinVisible(!pinVisible)
  }
  const stripe = useStripe()
  const { loadCardDetails, loadingCardDetails, cardDetails } = useCardDetails(
    card.externalId,
    card.id + '',
    ['pin.number']
  )

  const elements = stripe?.elements({
    fonts: [interFont],
  })

  useEffect(() => {
    if (!pinVisible) {
      return
    }

    if (!isCardDetails(cardDetails)) {
      loadCardDetails()
    } else if (isCardDetails(cardDetails)) {
      // @ts-expect-error:next-line
      const number = elements?.create('issuingCardPinDisplay', {
        style: pinStyle,
        issuingCard: card.externalId,
      })

      if (pinRef.current) {
        number?.mount(pinRef.current)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCardDetails(cardDetails), pinVisible])

  return {
    pinVisible,
    loading: loadingCardDetails,
    onSubmit: togglePinVisible,
    pinRef,
  }
}

export const CardPin: React.FC<{ card: CardDetailFragment }> = ({ card }) => {
  const { pinVisible, loading, onSubmit, pinRef } = useViewPin(card)

  return (
    <SidebarSection>
      <Box width="full">
        <Text.Normal weight="semibold" size="300" color="textPrimary">
          {i18n.t('expenses_v2.cards.pin.title')}
        </Text.Normal>
      </Box>
      <Box flexDirection="column" gap="s24" width="full">
        {pinVisible && !loading && <Box minWidth="s48" minHeight="s48" ref={pinRef}></Box>}
        {(!pinVisible || loading) && (
          <TextField label={i18n.t('expenses_v2.cards.pin.title')} value="****" readonly />
        )}
      </Box>
      <Box width="full" flexDirection="rowReverse">
        <Button
          type="secondary"
          onClick={onSubmit}
          disabled={loading || pinVisible}
          aria-label={i18n.t('expenses_v2.buttons.show_PIN')}
        >
          {i18n.t('expenses_v2.buttons.show_PIN')}
        </Button>
      </Box>
    </SidebarSection>
  )
}
